import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateVehicleSetupActions as Actions,
  UpdateVehicleSetupRequestAction as RequestAction,
} from 'store/ducks/vehicleSetups';

export function* updateVehicleSetupRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `vehicle-setups/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Configuração de veículo atualizada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
